import type { ReactNode, SVGAttributes } from 'react';

import { Icons } from './icons';

type IconName = keyof typeof Icons;

export interface IconProps extends Omit<SVGAttributes<SVGElement>, 'height' | 'width'> {
  /** The name of the icon to render. */
  name: IconName;
  /** The size (in pixels) of the icon to render. */
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  size?: 16 | 20 | 24 | 32 | 48 | 64 | 96 | 128;
  /** The title used for a tooltip. */
  title?: string;
}

const defaultSize = 24;

/** Represents a component to render an icon. */
export const Icon = ({ name, size = defaultSize, title, ...restProps }: IconProps): ReactNode => {
  const Icon = Icons[name];

  return <Icon aria-hidden={true} height={size} width={size} title={title} {...restProps} />;
};
